import { z } from 'zod';
export const operatingModeSchema = z.enum([
    'UNCLASSIFIED',
    'INTRODUCTION',
    'CLEANING',
    'CLEANUP_FAILED',
    'LIVE',
]);
export const introductionStatusSchema = z.object({
    mode: operatingModeSchema,
    phaseId: z.string().nullable(),
    version: z.number().int().positive(),
    environment: z.enum(['development', 'test', 'staging', 'production', 'unknown']),
    tenantName: z.string(),
});
export const introductionBlockerSchema = z.object({
    code: z.enum([
        'EXISTING_TRANSACTIONS',
        'SETUP_RELEASED',
        'LIVE_IRREVERSIBLE',
        'UNCLASSIFIED_DEPENDENCIES',
        'BACKUP_BRIDGE_UNAVAILABLE',
        'COVERAGE_INCOMPLETE',
    ]),
    area: z.string(),
    count: z.number().int().nonnegative(),
});
export const introductionPreviewSchema = z.object({
    status: introductionStatusSchema,
    digest: z.string().regex(/^[a-f0-9]{64}$/u),
    areas: z.array(z.object({
        area: z.string(),
        testCount: z.number().int().nonnegative(),
        preservedCount: z.number().int().nonnegative(),
    })),
    blockers: z.array(introductionBlockerSchema),
    files: z.number().int().nonnegative(),
    canActivate: z.boolean(),
    canReset: z.boolean(),
});
export const introductionActivationSchema = z
    .object({
    version: z.number().int().positive(),
    digest: z.string().regex(/^[a-f0-9]{64}$/u),
    tenantName: z.string().min(1).max(200),
    password: z.string().min(1).max(1024),
    confirmation: z.literal('EINFÜHRUNG AKTIVIEREN'),
})
    .strict();
export const introductionResetSchema = z
    .object({
    version: z.number().int().positive(),
    digest: z.string().regex(/^[a-f0-9]{64}$/u),
    tenantName: z.string().min(1).max(200),
    password: z.string().min(1).max(1024),
    intent: z.enum(['CONTINUE_TESTING', 'GO_LIVE']),
    confirmation: z.literal('TESTTRANSAKTIONEN LÖSCHEN'),
})
    .strict();
//# sourceMappingURL=introduction.js.map